export const BRAND = {
  website: 'audinexa.com', phone: '+91 95050 95777', phoneHref: 'tel:+919505095777', email: 'founder@audinexa.com',
};

export const INTRO_TEXT = 'Welcome to AudiNexa, the complete clinic management platform built for audiology and hearing care clinics in India. '
  + 'In this walkthrough, we will show you how AudiNexa runs every part of your clinic, from the front desk to the final invoice.';
export const OUTRO_TEXT = 'Thank you for watching. AudiNexa brings appointments, hearing tests, hearing-aid sales, inventory, repairs and billing together in one place. '
  + 'Book your free demo today. Visit audinexa dot com, call us on 9 5 0 5 0, 9 5 7 7 7, or write to founder at audinexa dot com.';
